"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterVisibleStrategies = void 0;
// @agentsNote Restrict only strategy selectors and prioritisation blocks; keep API data and save payloads unfiltered so hidden strategies are preserved.
var VISIBLE_STRATEGY_NAMES = new Set([
    'Business Value Strategy',
    'Employee Experience (XMO)',
]);
exports.filterVisibleStrategies = function (strategies) {
    return strategies.filter(function (strategy) { return VISIBLE_STRATEGY_NAMES.has(strategy.name); });
};
